
import Box from '@mui/material/Box'

import { styled } from '@mui/material/styles'
import { oneTimeRate, yearlyRate, monthlyRate } from './variableDefaults'

// Increment index by one 
export const incrementIndex = (index, setIndex) => {
  const newIndex = index + 1
  setIndex(newIndex)
}

// Decrement index by one 
export const decrementIndex = (index, setIndex) => {
  const newIndex = index - 1
  setIndex(newIndex)
}

// Reload View
export const reloadView = () => {
  window.location.reload()
}

// Input Element
export const Input = styled('input')({
  display: 'none',
}) 

// Dummy Box for Spacing
export const dummyBox = (height = '0px') => {
  return (
    <Box sx={{ height: height }}></Box>
  )
}

// Dummy Box for Spacing
export const dummyBoxWidth = (width = '0px', marginx = 0, key = 0) => {
  // console.log('key ->', key)
  return (
    <Box 
      key={key} 
      sx={{ 
        // backgroundColor: 'orange',
        mx: marginx, 
        minWidth: width,
      }}>

    </Box>
  )
}

export const isNumeric = (str) => {
  return /^\d+$/.test(str)
}

export const numberWithCommas = (x) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export const spacesRemovedFromString = (str) => {
  return str.replace(/\s+/g, '')
}

export const capitalizeFirstLetter = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export const getKeyByValue = (object, value) => {
  return Object.keys(object).find(key => object[key] === value)
}

export const shuffleArray = (array) => {
  return array
    .map(value => ({ value, sort: Math.random() }))
    .sort((a, b) => a.sort - b.sort)
    .map(({ value }) => value)
}

export const cmToInches = (number) => {
  return Math.round(number * 0.3937007874)
}

export const inchesToCm = (number) => {
  return Math.round(number * 2.54)
}

export const inchesToFeetString = (number) => {
  return `${Math.floor(number / 12)}' ${number % 12}''`
}

export const inchesToFeetStringTinder = (number) => {
  return `${Math.floor(number / 12)} ft ${number % 12} in`
}

// Check if it's a valid email address
export const validEmail = (email) => {
  return email && email.includes('@') && email.includes('.') && email.charAt(email.length - 1) !== '@' && email.charAt(email.length - 1) !== '.' && email.charAt(email.length - 2) !== '@' && email.charAt(email.length - 2) !== '.' && email.charAt(0) !== '@' && email.charAt(0) !== '.' && !email.includes(' ')
}

// Handles basic form input changes
export const handleChange = (e, setErrors, setFormData, formData) => {
  const { name, value } = e.target
  // console.log('name ->', name)
  // console.log('value ->', value)

  setErrors(false)
  setFormData({ ...formData, [name]: (name === 'email' ? value.toLowerCase().trim() :  value)  })
  
}

export const removeDuplicatesFromArray = (array) => {
  return [...new Set(array)]
}

export const noDuplicatesInArray = (array) => {
  return array.length === removeDuplicatesFromArray(array).length
}

export const isMobile = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}

export const isInstagramOrFacebook = () => {

  return /Instagram|FBAN|FBAV/.test(navigator.userAgent)
}

export const handleOpenInBrowser = (urlPath = '') => {
  const fullURL = `https://swipelytics.com/${urlPath}`

  // Open in new tab/window — which often forces default browser

  if (isInstagramOrFacebook()) {
    window.open(fullURL, '_blank')
    window.location = fullURL
  }
}

// One day ago
export const oneDayAgo = () => {
  const oneDayAgo = Date.parse(new Date((new Date()).valueOf() - 1000 * 60 * 60 * 24 * 1))
  return oneDayAgo
}

export const oneMinuteAgo = () => {
  const oneDayAgo = Date.parse(new Date((new Date()).valueOf() - 1000 * 60 * 1))
  return oneDayAgo
}

export const dateToNumber = (dateString) => {
  return Date.parse(dateString)
}

export const dateIsWithin24Hours = (dateString) => {
  const dateNumber = dateToNumber(dateString)
  const oneDayAgoNumber = oneDayAgo()

  return dateNumber > oneDayAgoNumber
}